var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"cesiumContainer",attrs:{"id":"cesium-container"}},[_c('cesium-recorder',{ref:"cesiumRecorder"})],1)}
var staticRenderFns = []
export { render, staticRenderFns }